import { PlatformSubscriptionStatus } from "../../Models/PlatformSubscription";
import api from "../axios";

export const platformSubscriptionService = {
  getStatus: async (): Promise<PlatformSubscriptionStatus> => {
    const response = await api.get("/platform-subscription/status");
    return response.data;
  },

  createPortal: async (): Promise<string> => {
    const response = await api.post("/platform-subscription/portal");
    return response.data.portalUrl;
  }
};
